"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const updateSuccessStatusFieldsForCheckpoint_1 = require("../helpers/updateSuccessStatusFieldsForCheckpoint");
const updateAccessDates_1 = require("../updateAccessDates");
const updateCompletionStatus_1 = require("../updateCompletionStatus");
const updateProgressMeasure_1 = require("../updateProgressMeasure");
const updateSubmissionCount_1 = require("../updateSubmissionCount");
function evaluateCheckpoint(command, user, content, states) {
    const events = [];
    let updatedStates = states;
    updatedStates = immer_1.produce(updatedStates, draftStates => {
        const progressMeasureEvents = updateProgressMeasure_1.updateProgressMeasure(command, user, content, draftStates, false);
        const completionStatusEvents = updateCompletionStatus_1.updateCompletionStatus(command, user, content, draftStates, false);
        updateSuccessStatusFieldsForCheckpoint_1.updateSuccessStatusFieldsForCheckpoint(user, content, draftStates);
        updateSubmissionCount_1.updateSubmissionCount(command, user, content, draftStates);
        const accessDatesEvents = updateAccessDates_1.updateAccessDates(command, user, content, draftStates);
        events.push(...progressMeasureEvents, ...completionStatusEvents, ...accessDatesEvents);
    });
    return { events, states: updatedStates, stateInteractions: [] };
}
exports.evaluateCheckpoint = evaluateCheckpoint;
//# sourceMappingURL=index.js.map